import translate from "../../../../../../global/directives/translate";
import UiZahlungsverkehrMixin from "../UiZahlungsverkehrMixin";
import PuxIcon from "../../../../../../global/components/PuxIcon/PuxIcon.vue";

// @vue/component
export default {
  name: "UiZahlungsverkehrReadOnly",
  components: {
    PuxIcon,
  },
  directives: {
    translate,
  },
  mixins: [
    UiZahlungsverkehrMixin,
  ],
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    className: {
      type: String,
      default: "",
    },
    model: {
      type: Object,
      required: true,
    },
  },
};
